import React from 'react';
import { Link } from 'react-router-dom';
import './Mission.css';

const PILLARS = [
  {
    icon: '🎓',
    iconClass: 'mission-card-icon-teal',
    title: 'Education',
    desc: 'Quality schooling and scholarships for underprivileged children.',
  },
  {
    icon: '💊',
    iconClass: 'mission-card-icon-amber',
    title: 'Healthcare',
    desc: 'Free medical camps and preventive care in rural areas.',
  },
  {
    icon: '👩',
    iconClass: 'mission-card-icon-blue',
    title: 'Women\'s Power',
    desc: 'Skill training and micro-finance for women entrepreneurs.',
  },
  {
    icon: '🌱',
    iconClass: 'mission-card-icon-purple',
    title: 'Sustainability',
    desc: 'Eco-friendly agriculture and clean water initiatives.',
  },
];

export default function Mission() {
  return (
    <section className="mission section" aria-labelledby="mission-heading">
      <div className="container">
        <div className="mission-inner">
          <div className="mission-visual">
            <div className="mission-img-wrap">
              <div className="mission-img-real">
                <img
                  src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=600&h=660&q=80"
                  alt="Community members joining hands for a better tomorrow"
                  className="mission-img"
                  loading="lazy"
                />
                <div className="mission-img-overlay" aria-hidden="true" />
              </div>
            </div>

            <div className="mission-accent-box" aria-hidden="true">
              <div className="mission-accent-num">15+</div>
              <div className="mission-accent-label">Years of<br />Trusted Service</div>
            </div>

            <div className="mission-accent-box-2" aria-hidden="true">
              <div className="mission-accent-badge-icon">🏆</div>
              <div className="mission-accent-badge-text">Award-Winning<br />NGO 2024</div>
            </div>
          </div>

          <div className="mission-content">
            <div className="section-header" style={{ textAlign: 'left', margin: 0 }}>
              <span className="section-label">Who We Are</span>
              <h2 className="section-title" id="mission-heading">
                Our Mission to Create Lasting Change
              </h2>
              <p className="section-subtitle">
                Founded in 2010, Shine People Trust believes that sustainable development starts with empowering individuals. We partner with communities to co-create solutions in education, health, and economic opportunity — building a future where every person can shine.
              </p>
            </div>

            <div className="mission-cards" role="list" aria-label="Our pillars of work">
              {PILLARS.map(p => (
                <div className="mission-card" key={p.title} role="listitem">
                  <div className={`mission-card-icon ${p.iconClass}`} aria-hidden="true">
                    {p.icon}
                  </div>
                  <div className="mission-card-title">{p.title}</div>
                  <div className="mission-card-desc">{p.desc}</div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: '2.5rem' }}>
              <Link to="/about" className="btn btn-primary">
                Learn Our Story &rarr;
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
